export default __webpack_public_path__ + "static/media/yvonne_ho.14e43262.jpg";